import React, { memo, useEffect, useState } from 'react';

import classNames from 'classnames';
import cn from 'classnames';
import $ from 'jquery';
import { useTranslation } from 'react-i18next';

import cls from './Onboard.module.css';
import {
    getFromLocalStorage,
    saveToLocalStorage,
} from '../../../TemporaryConmonents/Gant/helpers/localStorageHandler';

interface OnboardProps {
    classes?: string;
    text: string;
    localStorageKey: string;
    elementId: string;
    elementContent: React.ReactNode;
    elementHeight: number;
    elementWidth: number;
    isLeft?: boolean;
}

export const Onboard = memo(
    ({
        classes,
        text,
        localStorageKey,
        elementWidth,
        elementId,
        elementContent,
        elementHeight,
        isLeft = false,
    }: OnboardProps) => {
        const [isShowOnboard, setIsShowOnboard] = useState(
            getFromLocalStorage(localStorageKey) === null
        );

        const hide = () => {
            $('.container-scroller').css({
                height: '',
            });
            setIsShowOnboard(false);
            saveToLocalStorage(localStorageKey, false);
        };

        const { t } = useTranslation();
        const [position, setPosition] = useState<{ top: number; left: number }>({
            top: 0,
            left: 0,
        });

        useEffect(() => {
            if (isShowOnboard) {
                $('.container-scroller').css({
                    height: '100vh',
                });
            }
            const observer = new MutationObserver(() => {
                const positionTab = $(`#${elementId}`).offset();

                if (positionTab) {
                    setPosition(positionTab);
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });

            return () => {
                observer.disconnect();
            };
        }, []);

        if ((!position.left && !position.top) || !isShowOnboard) return null;
        return (
            <div className={classNames(cls.Onboard, [classes])}>
                <div
                    className={cls.measurementsOnboardTab}
                    style={{ top: position.top, left: position.left + 17 }}
                >
                    {elementContent}
                </div>
                <div
                    className={cn(
                        cls.measurementsOnboardModal,
                        isLeft && cls.measurementsOnboardModalLeft
                    )}
                    style={{ top: position.top + 50, left: position.left - (isLeft ? 180 : 7) }}
                >
                    <div className={cls.measurementsOnboardModalContent}>{text}</div>
                    <div className={cls.measurementsOnboardModalButton}>
                        <button onClick={hide}>{t('button.ok.text')}</button>
                    </div>
                </div>
            </div>
        );
    }
);
